import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '@redbubble/next-i18n';

const normaliseLocale = (locale: string): string => {
  return (
    SUPPORTED_LOCALES.find((l) => l === locale.toLowerCase()) || DEFAULT_LOCALE
  );
};

const helpCenterBaseUrl = 'https://help.redbubble.com/hc';
const zenDeskENLocale = 'en-us';

// NOTE (jj): We are currently using zendesk for help center, which uses "en-us". for english language code (specifically lowercase).
// We commonly use "en" for english locale, so we need to swap with en-us for zendesk to recognize the valid url.
// also note, zendesk does not recognise fr-FR, (or similar) as we have have in our current "Long form language codes" i18n constant
const getZenDeskLanguageCode = (locale: string) => {
  const normalisedLocale = normaliseLocale(locale);

  return (
    normalisedLocale === DEFAULT_LOCALE ? zenDeskENLocale : normalisedLocale
  ).toLowerCase();
};

export const getHelpCenterURL = (locale: string, articleId?: string) => {
  const languageCode = getZenDeskLanguageCode(locale);

  return `${helpCenterBaseUrl}/${languageCode}${
    !articleId ? '' : `/articles/${articleId}`
  }`;
};

export const shippingHelpUrl = (locale: string) =>
  getHelpCenterURL(locale, '217196086');

export const securePaymentsHelpUrl = (locale: string) =>
  getHelpCenterURL(locale, '206337916');

export const returnExchangePolicyHelpUrl = (locale: string) =>
  getHelpCenterURL(locale, '5857691382164');

export const helpCenterUrl = (locale: string) => getHelpCenterURL(locale);

const carbonNeutralUrls = {
  fr: 'https://www.redbubble.com/social-responsibility/fr/durabilite/compensation-carbone/',
  de: 'https://www.redbubble.com/social-responsibility/de/nachhaltigkeit/co2-ausgleich/',
  es: 'https://www.redbubble.com/social-responsibility/es/sostenibilidad/compensacion-de-carbono/',
  en: 'https://www.redbubble.com/social-responsibility/sustainability/carbon-offset/',
};
// XXX (jj): is there a better way to generate localised urls for the /social-responsibility pages?
export const carbonNeutralUrl = (locale: string) => {
  const languageCode = normaliseLocale(locale);

  return carbonNeutralUrls[languageCode] || carbonNeutralUrls.en;
};
